"use strict";

exports.__esModule = true;
exports.onRouteUpdate = void 0;

var onRouteUpdate = function onRouteUpdate() {
  // Don't track while developing.
  if (process.env.NODE_ENV === "production" && typeof FB === "function") {
    window.FB.AppEvents.logPageView();
  }
};

exports.onRouteUpdate = onRouteUpdate;